<template>
  <Teleport v-if="props.modelValue" to="body">
    <div class="iai-modal-wrapper fixed left-0 top-0 h-screen w-screen">
      <div
        class="iai-modal-backdrop h-full w-full"
        :class="{ 'cursor-pointer': !persistant }"
        @click="closeFromBackdrop"
      ></div>

      <div
        class="iai-modal-dialog fixed w-full"
        :class="[getPositionClasses]"
        :style="`max-width: ${maxWidth};`"
        @click="closeFromBackdrop"
      >
        <div
          class="relative mx-auto w-full cursor-default px-8 pb-10 pt-10"
          :class="[variant === 'primary' ? 'rounded bg-white' : 'rounded-[10px] bg-theme-1']"
          v-bind="$attrs"
          @click.stop
        >
          <img
            :class="{ hidden: !closeTopButton }"
            :src="CloseIcon.src"
            class="absolute right-4 top-4 box-content w-3 cursor-pointer rounded-md p-2 hover:bg-theme-disabled active:scale-90"
            alt=""
            @click="closeModal"
          />

          <slot></slot>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import CloseIcon from "../IAIIcon/icons/Close.svg";
import { computed } from "vue";

type PositionVariant =
  | "center"
  | "center-left"
  | "center-right"
  | "top-center"
  | "top-left"
  | "top-right"
  | "bottom-center"
  | "bottom-left"
  | "bottom-right";

const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    maxWidth?: string;
    closeTopButton?: boolean;
    persistant?: boolean;
    variant?: "primary" | "secondary";
    position?: PositionVariant;
  }>(),
  {
    modelValue: true,
    maxWidth: "35rem",
    closeTopButton: true,
    persistant: false,
    variant: "primary",
    position: "center",
  }
);

const emit = defineEmits(["update:modelValue"]);
const closeModal = () => {
  emit("update:modelValue", false);
};

const closeFromBackdrop = () => {
  if (!props.persistant) {
    closeModal();
  }
};

const getPositionClasses = computed(() => {
  const positions = {
    center: "left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
    "center-left": "left-8 top-1/2 -translate-y-1/2",
    "center-right": "right-8 top-1/2 -translate-y-1/2",
    "top-center": "left-1/2 top-8 -translate-x-1/2",
    "top-left": "left-8 top-8",
    "top-right": "right-8 top-8",
    "bottom-center": "left-1/2 bottom-8 -translate-x-1/2",
    "bottom-left": "left-8 bottom-8",
    "bottom-right": "right-8 bottom-8",
  };

  return positions[props.position];
});
</script>

<style lang="scss">
.iai-modal-wrapper {
  z-index: 6000;

  .iai-modal-backdrop {
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 5999;
  }
}
</style>
